// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"366":"e9f40453","682":"1fb3f35a","766":"62a9a9de","875":"ac3dbb88"}[chunkId] + ".css";
};